// extracted by mini-css-extract-plugin
export default {"empty":"ClientList_empty__t4Oqr","filterActive":"ClientList_filterActive__E8zfR","customerList":"ClientList_customerList__Zp4KB"};